// extracted by mini-css-extract-plugin
module.exports = {"brandRefresh":"DiscountTag_brandRefresh__qH0aQ"};